import { queryClient } from '../components/queryClient';
import { INTERNAL } from '../components/settings/AccessPolicies/constants';

// Lazy import to break circular dependency
const getUserProfileService = async () => {
  const { UserProfileService } = await import('./userProfile.service');
  return UserProfileService;
};

export const isInternal = async (): Promise<boolean> => {
  const UserProfileService = await getUserProfileService();
  const data = await queryClient.ensureQueryData({ queryKey: ['currentUser'], queryFn: UserProfileService.getMyProfile });
  const groupsFromQuery = await queryClient.ensureQueryData({ queryKey: ['groups-key'], queryFn: UserProfileService.getAllUserGroups });

  const groups = groupsFromQuery || [];
  const internalGroups = groups.filter((group) => group.scope === INTERNAL);

  return internalGroups.some((group) => group.name === data.primary_group);
};

export const isInternalSync = (): boolean => {
  const data = queryClient.getQueryData(['currentUser']);
  const groupsFromQuery = queryClient.getQueryData(['groups-key']);

  const groups = groupsFromQuery || [];
  const internalGroups = groups.filter((group) => group.scope === INTERNAL);

  const isInternalResult = internalGroups.some((group) => group.name === data.primary_group);

  return isInternalResult;
};
